import e from"react";import a from"@mui/icons-material/ExpandMore";const m=({className:m})=>e.createElement(a,{className:m});export{m as SelectIcon};
//# sourceMappingURL=SelectIcon.js.map
